/** Chuỗi của Cấu hình → Ưu đãi (KH-GĐ2 GĐ3). Tiếng Việt có dấu, câu ngắn. */
export const U = {
  tab: 'Ưu đãi khách mới',
  tieuDe: 'Ưu đãi chào khách mới',
  giaiThich:
    'Khách mới quét mã QR của tiệm là nhận được, lúc tính tiền quầy bấm một lần là áp. Số điện thoại khách vào sổ của tiệm.',
  kieu: 'Kiểu ưu đãi',
  tenKieu: { phan_tram: 'Giảm %', so_tien: 'Giảm tiền', tang_dich_vu: 'Tặng dịch vụ' } as const,
  phanTram: 'Giảm bao nhiêu phần trăm',
  soTien: 'Giảm bao nhiêu tiền',
  toiDa: 'Giảm tối đa (không bắt buộc)',
  toiDaGoiY: 'ví dụ 100.000',
  dichVu: 'Áp cho dịch vụ nào',
  dichVuTang: 'Tặng dịch vụ nào',
  moiDichVu: 'Mọi dịch vụ',
  han: 'Dùng được trong',
  soNgay: (n: number) => `${n} ngày`,
  toiNgay: (ngay: string) => `Tới hết ngày ${ngay}.`,
  suat: 'Tổng số suất',
  khachThay: (moTa: string) => `Khách sẽ thấy: “${moTa}”.`,
  canPhanTram: 'Chọn mức giảm từ 1 đến 100% để lưu.',
  canSoTien: 'Nhập số tiền giảm (từ 1.000đ) để lưu.',
  canDvTang: 'Chọn một dịch vụ để tặng rồi lưu.',
  canSuat: 'Nhập tổng số suất (ít nhất 1) để lưu.',
  batDau: 'Bắt đầu ưu đãi',
  luu: 'Lưu',
  dung: 'Tạm dừng nhận ưu đãi',
  chayLai: 'Cho nhận lại',
  daLuu: 'Đã lưu ưu đãi.',
  dangChay: (da: number, tong: number) => `Đang chạy · đã có ${da}/${tong} khách nhận.`,
  hetNhan: 'Hết suất hoặc hết hạn — khách chưa nhận được nữa.',
  tamDung: 'Đang tạm dừng — khách không thấy ưu đãi.',
  daCoKhach: 'Đã có khách nhận: chỉ đổi được hạn dùng và tổng số suất.',
  qr: 'Khách thấy ưu đãi khi quét mã QR đặt lịch của tiệm (Cấu hình → Mã QR đặt lịch).',
  soLieu: 'Kết quả',
  daNhan: 'Khách đã nhận',
  daDung: 'Khách đã dùng',
  tongThu: 'Tiền thu từ các lần dùng',
  tongGiam: 'Tiền đã giảm',
  quayLai: 'Khách quay lại lần hai',
} as const
